// Discagem a partir da pausa de sistema 25 (VOC-499). Puro, dependências injetadas.
import { SYSTEM_PAUSE_REASON_ID } from './systemPause.js'

export const SYSTEM_PAUSE_DIAL_TIMEOUT_MS = 5000
export const SYSTEM_PAUSE_DIAL_ERROR = 'Não foi possível sair da pausa para discar. Tente novamente.'

export const createSystemPauseDial = ({
  unpause, call, setSchedulePause, clearSchedulePause, notify,
  setTimeout: setTimer = globalThis.setTimeout,
  clearTimeout: clearTimer = globalThis.clearTimeout,
  warn = (...args) => console.warn(...args),
  timeoutMs = SYSTEM_PAUSE_DIAL_TIMEOUT_MS
}) => {
  let pending = null

  const isLocked = () => pending !== null

  const request = (params) => {
    if (pending) return false
    pending = { params, timer: null }
    setSchedulePause(SYSTEM_PAUSE_REASON_ID)
    pending.timer = setTimer(onTimeout, timeoutMs)
    unpause()
    return true
  }

  const onTimeout = () => {
    if (!pending) return
    pending = null
    clearSchedulePause()
    warn('[systemPauseDial] saída da pausa não confirmada; discagem abortada')
    notify(SYSTEM_PAUSE_DIAL_ERROR)
  }

  // Chamado a cada SIP Agent recebido.
  const onAgentStatus = (status) => {
    if (!pending || status === 'PAUSED') return
    const { params, timer } = pending
    clearTimer(timer)
    call(params)
    pending = null
  }

  return { request, onAgentStatus, isLocked }
}
